function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 10.586V4a1 1 0 00-2 0v6.586L5.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L9 10.586z",
  fill: "#243143"
});

function SvgArrowSortDown16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMTAuNTg1OFY0QzkgMy40NDc3MiA4LjU1MjI4IDMgOCAzQzcuNDQ3NzIgMyA3IDMuNDQ3NzIgNyA0VjEwLjU4NThMNS43MDcxMSA5LjI5Mjg5QzUuMzE2NTggOC45MDIzNyA0LjY4MzQyIDguOTAyMzcgNC4yOTI4OSA5LjI5Mjg5QzMuOTAyMzcgOS42ODM0MiAzLjkwMjM3IDEwLjMxNjYgNC4yOTI4OSAxMC43MDcxTDcuMjkyODkgMTMuNzA3MUM3LjY4MzQyIDE0LjA5NzYgOC4zMTY1OCAxNC4wOTc2IDguNzA3MTEgMTMuNzA3MUwxMS43MDcxIDEwLjcwNzFDMTIuMDk3NiAxMC4zMTY2IDEyLjA5NzYgOS42ODM0MiAxMS43MDcxIDkuMjkyODlDMTEuMzE2NiA4LjkwMjM3IDEwLjY4MzQgOC45MDIzNyAxMC4yOTI5IDkuMjkyODlMOSAxMC41ODU4WiIgZmlsbD0iIzI0MzE0MyIvPgo8L3N2Zz4K";
export { SvgArrowSortDown16 as ReactComponent };